export default __webpack_public_path__ + "c6dbad8e9e418d2980a9cacbd7c4e63b.png";